export const getStockTags = state => state.tags.stockTags;
export const getAllTags = state => state.tags.allTags;
export const getSingleTagDetails = state => state.tags.singleTagDetails;
export const getTagsWithQuery = state => state.tags.tagsWithQuery;
export const getStocksFromSource = state => state.tags.stocksList;
export const getStocksListSource = state => state.tags.stocksList.source;
export const getAllAvailableTags = state => state.tags.allAvailableTags;
export const getTagsInNeedOfRefresh = state => state.tags.tagsInNeedOfRefresh;
